export const AccountTypes = {
    CHECKING: 'Checking',
    SAVINGS: 'Savings'
}

export type AccountType = 'CHECKING' | 'SAVINGS'

export interface PaymentAccount {
    holderName: string,
    type: AccountType,
    institution: string,
    routingNumber: string,
    number: string
}
